import axios from 'axios';

// Enable credentials for cross-site Access-Control requests.
axios.defaults.withCredentials = true;

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
};

export default axios;
